export default __DEV__ ? "dev" : "prod";
